
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCDs2SAFrhUY9T7fbalblAQtbUoZVGJojk",
  authDomain: "vitabridge-4ed9e.firebaseapp.com",
  projectId: "vitabridge-4ed9e",
  storageBucket: "vitabridge-4ed9e.firebasestorage.app",
  messagingSenderId: "381382883790",
  appId: "1:381382883790:web:5b179a42b8e6c5a7cb139f",
  measurementId: "G-J3B9M5YMDY"
};

const Firebase = initializeApp(firebaseConfig);
const analytics = getAnalytics(Firebase);
const db = getFirestore(Firebase)
export {Firebase,db }